import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { observer } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './style.module.less';

@withRouter
@observer
@BindAll()
export class Protocol extends React.Component {
  hideModal = () => {
    this.$MergeQuery({ protocol: '' }, true);
  };
  get id() {
    return lodash.get(this.$router.query, 'protocol');
  }
  get isVisible() {
    return !!this.id;
  }
  get protocolInfo() {
    return lodash.find(this.$Store.Protocol.protocolList, ['id', this.id]);
  }
  get content() {
    const opType = lodash.get(this.protocolInfo, 'opType');
    if(opType == 1) {
      return lodash.get(this.protocolInfo, 'protocolFileUrl')
    }
    if(opType == 2) {
      return lodash.get(this.protocolInfo, 'protocolContent')
    }
    return '';
  }
  componentDidMount() {}
  renderContent() {
    if(!this.content) {
      return <React.Antd.Empty />
    }
    if(this.protocolInfo.opType == 2) {
      return  <div
        className={styles.protocol}
        dangerouslySetInnerHTML={{
          __html: this.protocolInfo.protocolContent,
        }}
      ></div>
    }
    if(this.protocolInfo.opType == 1) {
      return <React.Antd.Empty description="暂不支持pdf" />
    }
    return null
  }
  render() {
    if (lodash.isEmpty(this.protocolInfo)) {
      return null;
    }
    return (
      <React.Antd.Modal
        title={this.protocolInfo.name}
        visible={this.isVisible}
        onCancel={this.hideModal}
        // okText="确认"
        width={800}
        footer={
          [
            // <React.Antd.Button type='primary' key="ok" onClick={this.hideModal}>确认</React.Antd.Button>
          ]
        }
      >
        {this.renderContent()}
      </React.Antd.Modal>
    );
  }
}
